<template>
  <div>
    <div v-if="isEmpty"></div>
    <taskToday3 v-else />
  </div>
</template>

<script>
export default {
  components: {
    taskToday3: () => import("./w/tasksToday3.vue"),
  },
  data() {
    return {};
  },
  computed: {
    isEmpty() {
      const mm = this.$store.getters["config/get"]?.config?.mainMenu;
      return mm.find((m) => {
        return m.route.name == this.$route.name;
      })?.empty;
    },
  },
  created() {
    this.$root.title = "Главная";
  },
  methods: {},
};
</script>
